function gfGeneral(){
    const selectPlaceholder = document.querySelectorAll('select option.gf_placeholder');
    selectPlaceholder?.forEach((item) => {
        item.setAttribute('disabled', true);
        item.setAttribute('hidden', true);
    })
}

document.addEventListener('DOMContentLoaded', ()=> {
    gfGeneral()
});
jQuery(document).on('gform_post_render', function(){
    gfGeneral()
});